import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconAudio = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M8.07351 2.25103C8.72009 1.69174 9.72335 2.15206 9.72335 3.00804V13.0031C9.72335 13.8341 8.77062 14.3026 8.11482 13.794L3.98046 10.5877H2.49677C1.67013 10.5877 1 9.9161 1 9.08772V7.30451C1 6.47608 1.67013 5.80451 2.49677 5.80451H3.96542L8.07351 2.25103ZM8.7255 3.00804L4.3365 6.80451H2.49677C2.22122 6.80451 1.99785 7.02837 1.99785 7.30451V9.08772C1.99785 9.36386 2.22122 9.58772 2.49677 9.58772H4.32146L8.7255 13.0031V3.00804Z"
        fill="currentColor"
      />
      <path
        d="M12.3652 3.04202C12.5764 2.86459 12.8911 2.89229 13.0681 3.10389C14.2351 4.49858 14.9496 6.21513 14.9974 8.08991C15.049 10.108 14.3196 11.9814 13.0662 13.4953C12.8903 13.7078 12.5757 13.7371 12.3637 13.5608C12.1516 13.3845 12.1223 13.0693 12.2983 12.8568C13.4138 11.5093 14.0446 9.8673 13.9999 8.11548C13.9584 6.48718 13.339 4.98405 12.3035 3.74642C12.1265 3.53482 12.1541 3.21945 12.3652 3.04202Z"
        fill="currentColor"
      />
      <path
        d="M10.772 4.9012C10.9731 4.71242 11.2888 4.72276 11.4772 4.92429C12.2995 5.80407 12.8135 6.89729 12.8453 8.10405C12.8796 9.40438 12.3478 10.5992 11.4634 11.559C11.2765 11.7619 10.9608 11.7744 10.7584 11.5871C10.5559 11.3998 10.5434 11.0834 10.7303 10.8806C11.4701 10.0777 11.874 9.12685 11.8478 8.13046C11.8233 7.20418 11.4304 6.337 10.7489 5.60793C10.5606 5.40639 10.5709 5.08998 10.772 4.9012Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
